import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconLamp: React.FC<IconProps> = ({ ...props }) => {
  return (
    <Icon {...props}>
      <mask id="path-1-inside-1" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.3744 18.0397C17.2277 15.8726 18.6783 12.9628 18.6783 10.7794C18.6783 7.35441 15.6948 4.57787 12.0144 4.57787C8.33405 4.57787 5.35052 7.35441 5.35052 10.7794C5.35052 12.9829 6.86085 15.9262 8.74088 18.0994C8.41374 18.3836 8.20689 18.8027 8.20689 19.2701C8.20689 20.1264 8.90103 20.8205 9.75729 20.8205H14.431C15.2873 20.8205 15.9814 20.1264 15.9814 19.2701C15.9814 18.7688 15.7435 18.3231 15.3744 18.0397Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3744 18.0397C17.2277 15.8726 18.6783 12.9628 18.6783 10.7794C18.6783 7.35441 15.6948 4.57787 12.0144 4.57787C8.33405 4.57787 5.35052 7.35441 5.35052 10.7794C5.35052 12.9829 6.86085 15.9262 8.74088 18.0994C8.41374 18.3836 8.20689 18.8027 8.20689 19.2701C8.20689 20.1264 8.90103 20.8205 9.75729 20.8205H14.431C15.2873 20.8205 15.9814 20.1264 15.9814 19.2701C15.9814 18.7688 15.7435 18.3231 15.3744 18.0397Z"
        fill="#FFD338"
      />
      <path
        d="M15.3744 18.0397L14.6144 17.3897L13.9293 18.1909L14.7654 18.8328L15.3744 18.0397ZM8.74088 18.0994L9.39677 18.8542L10.15 18.1997L9.49715 17.4451L8.74088 18.0994ZM17.6783 10.7794C17.6783 11.6707 17.3757 12.7937 16.8154 13.9921C16.2609 15.1782 15.4849 16.3718 14.6144 17.3897L16.1344 18.6896C17.1171 17.5405 17.9931 16.1956 18.6272 14.8391C19.2556 13.495 19.6783 12.0715 19.6783 10.7794H17.6783ZM12.0144 5.57787C15.2114 5.57787 17.6783 7.97319 17.6783 10.7794H19.6783C19.6783 6.73563 16.1781 3.57787 12.0144 3.57787V5.57787ZM6.35052 10.7794C6.35052 7.97319 8.8174 5.57787 12.0144 5.57787V3.57787C7.8507 3.57787 4.35052 6.73563 4.35052 10.7794H6.35052ZM9.49715 17.4451C8.61259 16.4226 7.81523 15.2181 7.24309 14.0199C6.66462 12.8084 6.35052 11.6751 6.35052 10.7794H4.35052C4.35052 12.0872 4.7916 13.5273 5.43829 14.8817C6.09132 16.2493 6.98914 17.603 7.98462 18.7536L9.49715 17.4451ZM9.20689 19.2701C9.20689 19.1044 9.27891 18.9566 9.39677 18.8542L8.08499 17.3445C7.54857 17.8106 7.20689 18.501 7.20689 19.2701H9.20689ZM9.75729 19.8205C9.45331 19.8205 9.20689 19.5741 9.20689 19.2701H7.20689C7.20689 20.6787 8.34875 21.8205 9.75729 21.8205V19.8205ZM14.431 19.8205H9.75729V21.8205H14.431V19.8205ZM14.9814 19.2701C14.9814 19.5741 14.735 19.8205 14.431 19.8205V21.8205C15.8396 21.8205 16.9814 20.6787 16.9814 19.2701H14.9814ZM14.7654 18.8328C14.8986 18.9351 14.9814 19.0928 14.9814 19.2701H16.9814C16.9814 18.4449 16.5884 17.711 15.9834 17.2465L14.7654 18.8328Z"
        fill="#200E32"
        mask="url(#path-1-inside-1)"
      />
      <rect
        x="8.86254"
        y="21.4618"
        width="6.92695"
        height="0.461534"
        rx="0.230767"
        fill="#200E32"
        stroke="#200E32"
        strokeWidth="0.461534"
      />
      <rect
        x="9.78619"
        y="22.3845"
        width="5.07983"
        height="0.461534"
        rx="0.230767"
        fill="#200E32"
        stroke="#200E32"
        strokeWidth="0.461534"
      />
      <rect
        x="10.7098"
        y="23.3077"
        width="3.23271"
        height="0.461534"
        rx="0.230767"
        fill="#200E32"
        stroke="#200E32"
        strokeWidth="0.461534"
      />
      <rect
        width="3.47531"
        height="0.423255"
        rx="0.211627"
        transform="matrix(0.849172 -0.528117 0.582878 0.81256 1.35083 16.767)"
        fill="#200E32"
      />
      <rect
        width="2.93831"
        height="0.413826"
        rx="0.206913"
        transform="matrix(0.995649 -0.0931876 0.107331 0.994224 1.22467 12.5293)"
        fill="#200E32"
      />
      <rect
        width="2.88363"
        height="0.422517"
        rx="0.211259"
        transform="matrix(0.862246 0.50649 -0.56132 0.827599 2.91821 5.90642)"
        fill="#200E32"
      />
      <rect
        width="2.75788"
        height="0.441035"
        rx="0.220518"
        transform="matrix(0.342502 0.939518 -0.953601 0.301074 8.7998 1.77188)"
        fill="#200E32"
      />
      <rect
        width="2.7527"
        height="0.441773"
        rx="0.220886"
        transform="matrix(-0.299062 0.954234 -0.965082 -0.261951 15.9799 1.83092)"
        fill="#200E32"
      />
      <rect
        width="2.87889"
        height="0.423255"
        rx="0.211627"
        transform="matrix(-0.849298 0.527914 -0.583083 -0.812413 21.5644 6.52057)"
        fill="#200E32"
      />
      <rect
        width="2.93517"
        height="0.414333"
        rx="0.207166"
        transform="matrix(-0.988685 -0.150012 0.172565 -0.984998 22.6918 13.4246)"
        fill="#200E32"
      />
      <rect
        width="3.54561"
        height="0.414016"
        rx="0.207008"
        transform="matrix(0.993038 0.117793 -0.135554 0.99077 0.0560913 9.00732)"
        fill="#200E32"
      />
      <rect
        width="3.41879"
        height="0.430408"
        rx="0.215204"
        transform="matrix(0.704602 0.709603 -0.758201 0.652022 4.38171 2.33221)"
        fill="#200E32"
      />
      <rect
        width="3.30317"
        height="0.444094"
        rx="0.222047"
        transform="matrix(0.00487612 -0.999988 0.999991 0.00422303 11.6971 3.30313)"
        fill="#200E32"
      />
      <rect
        width="3.40735"
        height="0.431583"
        rx="0.215791"
        transform="matrix(0.673038 -0.739608 0.785403 0.618985 17.2505 4.88342)"
        fill="#200E32"
      />
      <rect
        width="3.54392"
        height="0.414243"
        rx="0.207122"
        transform="matrix(0.98992 -0.141628 0.162988 0.986628 20.424 9.50928)"
        fill="#200E32"
      />
      <rect
        width="3.48481"
        height="0.422028"
        rx="0.211014"
        transform="matrix(0.870667 0.491874 -0.546346 0.837559 19.7253 15.0613)"
        fill="#200E32"
      />
      <path
        d="M11.9994 7.65106C11.9994 7.65106 13.5073 7.41877 14.7638 8.58018C16.1517 9.86299 15.7691 10.903 15.7691 10.903"
        stroke="#200E32"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default IconLamp;
